import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-eula',
    templateUrl: './eula.component.html',
    styleUrls: ['./eula.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EulaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
